var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"from_area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"txt col col-12 col-sm-6"},[_c('formtxt')],1),_c('div',{staticClass:"input col col-12 col-sm-6"},[_c('Form')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }